import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Reservation, Shift, Table } from 'src/app/model/reservation';
import { WorkingDate, Section, TableImageType, TableRotation, TypeOfModification, BatchSynchRequestUpdated, TablesMode, OnlineReservationCategory, ExcluceFromOnlineChannelsMode, Settings, SettingsDataResponse, SettingsDataRequest, TablesPlanUpdateResponse } from 'src/app/model/tables-plan';

export const TablesPlanActions = createActionGroup({
  source: 'TablesPlan',
  events: {

    'No Action': emptyProps(),

    'Reset Tables Plan Editing State': emptyProps(),

    // global options
    'Set Mode': props<{ editMode: boolean, restaurantId: string, modifiedBy: string, workingDate: Date }>(),
    'Set Reservation Assign Tables Mode': props<{ assignMode: boolean, reservation: Reservation }>(),
    'Set Conflicting Tables': props<{ tables: Table[] }>(),
    'Add Conflicting Table': props<{ table: Table }>(),
    'Remove Conflicting Table': props<{ table: Table }>(),
    'Set Conflicting Reservations': props<{ reservations: Reservation[] }>(),
    'Set Reservation Allocated Tables And Submit': props<{ reservation: Reservation, allocatedTables: string[] }>(),
    // 'Set Swap Table Names': props<{ tableNames: string[] }>(),
    'Set Show Surname': props<{ show: boolean }>(),
    'Set Show Progress': props<{ show: boolean }>(),
    'Set Show Tables Connection': props<{ show: boolean }>(),

    // tables plan actions
    'Load Tables Plan': emptyProps(),
    'Load Tables Plan Success': props<{ workingDate: WorkingDate, sections: Section[], tables: Table[] }>(),
    'Load Tables Plan Failure': props<{ error: unknown }>(),

    'Set Canvas Rect': props<{ rect: DOMRect }>(),

    'Load Tables Plan Options': emptyProps(),
    'Load Tables Plan Options Success': props<{
      zoom: number, options: {
        showSurname: boolean,
        showProgress: boolean,
        showTablesConnection: boolean,
      }
    }>(),
    'Load Tables Plan Options Failure': props<{ error: unknown }>(),

    'Set Working Date': props<{ workingDate: WorkingDate | null | undefined }>(),
    'Set Section': props<{ section: Section | null | undefined }>(),

    'Set Zoom': props<{ zoom: number }>(),

    'Select Table': props<{ table: Table }>(),
    'Deselect Table': props<{ table: Table }>(),
    'Set Selected Tables': props<{ tables: Table[] }>(),

    'Select Allocated Table': props<{ table: Table }>(),
    'Deselect Allocated Table': props<{ table: Table }>(),
    'Set Allocated Tables': props<{ tables: Table[] }>(),
    'Set Reset Allocated Tables On Selection': props<{ value: boolean }>(),

    'Set Side Panel Collapsed': props<{ collapsed: boolean }>(),

    // edit mode
    'Set Editing Table': props<{ table: Table, isNew: boolean }>(),
    'Set Editing Table Name': props<{ name: string }>(),
    'Set Editing Table Min Capacity': props<{ min: number }>(),
    'Set Editing Table Max Capacity': props<{ max: number }>(),
    'Set Editing Table Rotation': props<{ rotation: TableRotation }>(),
    'Set Editing Table Order': props<{ order: number }>(),
    'Set Table Position': props<{ table: Table, x: number, y: number, typeOfModification: TypeOfModification, modifiedBy: string }>(),
    'Save Editing Table': props<{ modifiedBy: string }>(),
    'Cancel Edit Table': emptyProps(),
    'Delete Editing Table': props<{ modifiedBy: string }>(),
    'Create Section': props<{ section: Section, modifiedBy: string }>(),
    'Update Section': props<{ section: Section, modifiedBy: string }>(),
    'Delete Section': props<{ section: Section, modifiedBy: string }>(),
    'Set Tables Mode': props<{ mode: TablesMode }>(),
    'Set Add Joined Tables Mode': props<{ addJoinedTablesMode: boolean }>(),
    'Set Selected Online Category To Assign': props<{ onlineCategory: OnlineReservationCategory }>(),
    'Add Joined Table': props<{ allocatedTableIds: string[], modifiedBy: string }>(),
    'Delete Joined Table': props<{ joinedTable: Table, modifiedBy: string }>(),
    'Update Joined Table': props<{ joinedTable: Table, modifiedBy: string }>(),
    'Assign Online Category To Tables': props<{ tables: Table[], alteredTables: Table[], modifiedBy: string }>(),
    'Set Exclude From Channels Mode': props<{ mode: ExcluceFromOnlineChannelsMode, modifiedBy: string }>(),
    'Exclude From Online Channels': props<{ tables: Table[], alteredTables: Table[], modifiedBy: string }>(),

    'Add Pending Tables Plan': props<{ tablesPlan: BatchSynchRequestUpdated }>(),
    'Add Pending Tables Plan Success': emptyProps(),
    'Set Pending Table Plans': props<{ tablePlans: BatchSynchRequestUpdated[] }>(),
    'Submit Pending Tables Plan': emptyProps(),
    'Submit Pending Tables Plan Success': props<{ tablesPlan: BatchSynchRequestUpdated }>(),
    'Submit Pending Tables Plan Failure': props<{ error: any }>(),

    'Save Tables Plan': emptyProps(),
    'Save Tables Plan Success': emptyProps(),
    'Save Tables Plan Failure': props<{ error: unknown }>(),

    'Restore Regular Tables Plan': props<{ modifiedBy: string }>(),
    'Restore Regular Tables Plan Success': emptyProps(),
    'Restore Regular Tables Plan Failure': props<{ error: unknown }>(),
    'Save Tables Plan As Regular': props<{ workingDate: Date, modifiedBy: string }>(),
    'Save Tables Plan As Regular Success': emptyProps(),
    'Save Tables Plan As Regular Failure': props<{ error: unknown }>(),
    'Delete Old Regular Working Date': props<{ workingDate: WorkingDate | null, modifiedBy: string }>(),

    'Load Has Opened Tables Plan': emptyProps(),
    'Set Has Opened Tables Plan': props<{
      hasOpenedTablesPlan: boolean
    }>(),

    // settings
    'Load Settings': emptyProps(),
    'Load Settings Success': props<SettingsDataResponse>(),
    'Load Settings Failure': props<{ error: unknown }>(),
    'Save Settings': props<{ restaurantSettings: SettingsDataRequest }>(),
    'Save Settings Success': props<{ restaurantSettings: SettingsDataRequest }>(),
    'Save Settings Failure': props<{ error: unknown }>(),

    'Empty Action': emptyProps(),
  }
});
